import { Metadata, PostHogCapture } from './types'

const EVENT_CATEGORY = 'drag'
const EVENT_DRAG_STARTED = 'drag_started'
const EVENT_DRAG_ENDED = 'drag_ended'

export const trackDragStart =
  (track: PostHogCapture) => (metadata: Metadata) => {
    void track(EVENT_DRAG_STARTED, {
      ...metadata,
      category: EVENT_CATEGORY,
      label: metadata.name,
    })
  }

export const trackDragEnd = (track: PostHogCapture) => (metadata: Metadata) => {
  void track(EVENT_DRAG_ENDED, {
    ...metadata,
    category: EVENT_CATEGORY,
    label: metadata.name,
  })
}
